import type { DeleteDocumentMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteDocumentDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteDocument = createMutationHook({
  name: 'deleteDocument',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.document.delete.mutationOptions({ onSuccess }),
  mapInput: (id: string) => ({ id }),
  invalidate: (trpc) => [
    trpc.frontend.document.register.queryKey(),
    trpc.frontend.document.documentById.queryKey(),
    trpc.frontend.document.list.queryKey(),
  ],
  // trpc throws if no rows are affected — a resolved delete always reports a
  // single affected row.
  mapResponse: (): DeleteDocumentMutation => ({
    deleteDocumentById: {
      __typename: 'GenericMutationOutput',
      affected_rows: 1,
    },
  }),
  graphqlDocument: DeleteDocumentDocument,
  graphqlVariables: (id: string) => ({ id }),
  evictFields: ['document'],
});
